import FormAV2 from "components/FormA_v2";
import FormBV2 from "components/FormB_v2";
import FormAVO from "components/FormA_vo";
import FormACS from "components/FormA_cs";
import FormACS1 from "components/FormA_cs_1";
import FormAEXCP from "components/FormA_ex_cp";
import FormAEXCS from "components/FormA_ex_cs";
import FormAEXRB from "components/FormA_ex_rb";
import Wallet from "components/Wallet";
import Login from "components/Login";
import Main from "components/Main";
import PAccount from "components/PAccount";
import NeedAuth from "components/common/NeedAuth";
import Reg from "components/Reg";
import CMSTableWithUser from "components/common/CMSTableWithUser";
import ForgetPWD from "components/ForgetPWD";
import ResetPWD from "components/ResetPWD";
import Profile from "components/Profile";
import CMSTableWithForm from "components/common/CMSTableWithForm";
import AfterPayment from "components/common/AfterPayment";
import Admin from "components/common/Admin";
import ToHome from "components/common/ToHome";
import Enquiry from "components/Enquiry";
import { filters, resp_service_filter, service_filter } from "config/const/global";
import CMSTableWithPackage from "components/common/CMSTableWithPackage";
import DetailForm from "components/DetailForm";
import { getKeyByValue } from 'utils/getKeyByValue';
import CMSTableWithCredit from "components/common/CMSTableWithCredit";

let hkl = getKeyByValue(resp_service_filter.value.value, resp_service_filter.value.value.hongkong) + '.' +
    getKeyByValue(resp_service_filter.value.value.hongkong, resp_service_filter.value.value.hongkong.limited_company)
let virtual_office = getKeyByValue(resp_service_filter.value.value.value_added_service, resp_service_filter.value.value.value_added_service.virtual_office)
let BVI = getKeyByValue(resp_service_filter.value.value, resp_service_filter.value.value.BVI)
let cayman = getKeyByValue(resp_service_filter.value.value, resp_service_filter.value.value.cayman)
let seychelles = getKeyByValue(resp_service_filter.value.value, resp_service_filter.value.value.seychelles)
let company_secretary_company_secretary_services = resp_service_filter.value.value.company_secretary.company_secretary_services
let company_secretary_annual_return_service = resp_service_filter.value.value.company_secretary.annual_return_service
// let tm = getKeyByValue(resp_service_filter.value.value.value_added_service, resp_service_filter.value.value.value_added_service.va_trademark_registration)
let tm = getKeyByValue(resp_service_filter.value.value, resp_service_filter.value.value.value_added_service) + '.' +
    getKeyByValue(resp_service_filter.value.value.value_added_service, resp_service_filter.value.value.value_added_service.trademark_registration)
let business_name_card = 'business_name_card'
let customized_seal = getKeyByValue(resp_service_filter.value.value.value_added_service, resp_service_filter.value.value.value_added_service.customized_seal)


export const routes = [
    {
        path: '/login',
        element: <Login />
    },
    {
        path: '/reg',
        element: <Reg />
    },
    {
        path: '/forgetPwd',
        element: <ForgetPWD />
    },
    {
        path: '/resetPwd',
        element: <ResetPWD />
    },
    {
        path: '/',
        element: (
            <NeedAuth>
                <Main />
            </NeedAuth>
        ),
        children: [
            {
                path: 'individualAcc',
                element: <PAccount />,
            },
            {
                path: 'detailed',
                element: <DetailForm />
            },
            {
                path: 'apply',
                children: [
                    {
                        path: 'so',
                        element: <FormAV2 serveAs={service_filter.so} />
                    },
                    {
                        path: 'vo',
                        element: <FormAVO serveAs={virtual_office} />
                    },
                    {
                        path: 'cs',
                        element: <FormACS serveAs={company_secretary_company_secretary_services} />
                    },
                    {
                        path: 'cs1',
                        element: <FormACS1 serveAs={company_secretary_annual_return_service} />
                    },
                    {
                        path: 'excs',
                        element: <FormAEXCS serveAs={customized_seal} />
                    },
                    {
                        path: 'cp',
                        element: <FormAEXCP serveAs={business_name_card} />
                    },
                    {
                        path: 'rb',
                        element: <FormAEXRB serveAs={tm} />
                    },
                    {
                        path: 'hk',
                        children: [
                            {
                                path: 'l',
                                element: <FormAV2 serveAs={hkl} />
                            },
                            // {
                            //     path: 'ul',
                            //     element: <FormAV2 serveAs={service_filter.hk_ul} />
                            // }
                        ]
                    },
                    {
                        path: 'os',
                        children: [
                            {
                                path: 'BVI',
                                element: <FormBV2 serveAs={BVI} />
                            },
                            {
                                path: 'cayman',
                                element: <FormBV2 serveAs={cayman} />
                            },
                            {
                                path: 'seychelles',
                                element: <FormBV2 serveAs={seychelles} />
                            }
                        ]
                    },
                ]
            },
            {
                path: 'admin',
                children: [
                    {
                        path: 'services',
                        element: (
                            <Admin>
                                <CMSTableWithPackage />
                            </Admin>
                        )
                    },
                    {
                        path: 'credits',
                        element: (
                            <Admin>
                                <CMSTableWithCredit />
                            </Admin>
                        )
                    },
                    {
                        path: 'so',
                        element: (
                            <Admin>
                                <CMSTableWithForm filter={filters.so} />
                            </Admin>
                        )
                    },
                    {
                        path: 'vo',
                        element: (
                            <Admin>
                                <CMSTableWithForm filter={filters.vo} />
                            </Admin>
                        )
                    },
                    {
                        path: 'hk',
                        children: [
                            {
                                path: 'l',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.hk_l} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'ul',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.hk_ul} />
                                    </Admin>
                                )
                            }
                        ]
                    },
                    {
                        path: 'os',
                        children: [
                            {
                                path: 'BVI',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.os_bvi} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'cayman',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.os_cayman} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'seychelles',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.os_seychelles} />
                                    </Admin>
                                )
                            }
                        ]
                    },
                    {
                        path: 'as',
                        children: [
                            {
                                path: 'proxy',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.as_proxy} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'tax',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.as_tax} />
                                    </Admin>
                                )
                            }
                        ]
                    },
                    {
                        path: 'va',
                        children: [
                            {
                                path: 'cs',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.company_secretary_company_secretary_services} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'cs1',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.company_secretary_annual_return_service} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'tr',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.va_trademark_registration} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'bar',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.va_bank_account_registration} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'bnc',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.va_business_name_card} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'be',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.va_business_email} />
                                    </Admin>
                                )
                            },
                            {
                                path: 'csl',
                                element: (
                                    <Admin>
                                        <CMSTableWithForm filter={filters.va_customized_seal} />
                                    </Admin>
                                )
                            }
                        ]
                    },
                ]
            },
            {
                path: 'payment',
                children: [
                    {
                        path: 'success',
                        element: <AfterPayment msg={"成功"} />
                    },
                    {
                        path: 'failed',
                        element: <AfterPayment msg={"失敗"} />
                    },
                    {
                        path: 'cancel',
                        element: <AfterPayment msg={"取消"} />
                    }
                ]
            },
            {
                path: 'users',
                element: (
                    <Admin>
                        <CMSTableWithUser />
                    </Admin>
                )
            },
            {
                path: 'profile',
                element: <Profile />
            },
            {
                path: 'sug',
                element: <Enquiry />
            },
            {
                path: 'wallet',
                element: <Wallet />,
            },
            {
                path: '/',
                // element: <Navigate to={'/individualAcc'} />
                element: <ToHome />
            }
            // {
            //     path: '',
            //     element: <Dashboard />
            // }
        ]
    }
]